import React from 'react';
import UsersManagement from '../components/UsersManagement';

export default function UsersPage() {
  return <UsersManagement mode="owner" />;
}
